import { render, staticRenderFns } from "./couponTemplet.vue?vue&type=template&id=78579669&"
import script from "./couponTemplet.vue?vue&type=script&lang=js&"
export * from "./couponTemplet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports